import {Injectable} from '@angular/core';
import {GlobalService} from '../global/global.service';
import {AuthService} from '../auth/auth.service';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {ApiResponse, handleError} from '../utils';
import {searchCompanies, searchTeams} from '../variables';
import {catchError} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  constructor(public globalService: GlobalService,
              public auth: AuthService,
              public http: HttpClient) {
  }

  searchTeams(page, query): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(searchTeams + '/' + query + '?page=' + page, {headers: this.auth.jsonheader}).pipe(
      catchError(handleError)
    );
  }

  searchCompanies(page, query): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(searchCompanies + '/' + query + '?page=' + page, {headers: this.auth.jsonheader}).pipe(
      catchError(handleError)
    );
  }
}
